module.exports = require('./lib/Draggable').default;
module.exports.DraggableCore = require('./lib/DraggableCore').default;



// WEBPACK FOOTER //
// ./index.js